/**
 * Created by sammy on 1/21/20.
 * Project: webapp-template. File: AppRoutes
 */
import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AZURE_STORAGE_PLANNER_ROUTE } from "../integrations/azureStoragePlanner/AzureStoragePlannerHelpers";

export const APP_ROUTES = {
    PROJECTS: "/projects",
    USER: "/profile",
    USER_LICENSE: "/user-license",
    CALLBACKS: "/callbacks", //for hooks, oid, saml, etc.
    SUPPORT_PROJECTS: "/support-projects",
    REPORTS: "/reports",
    CUSTOMER_CENTER: "/customer-center",
};

export const AUTH_ROUTES = {
    SET_PASSWORD: "/set-password",
    SIGN_UP: "/sign-up",
    CONNECT_AWS: "/aws-mp-signup",
    CONNECT_AZURE: "/azure-mp-signup",
};

export const UNAUTHENTICATED_ROUTES = {
    MIGRATEOPS_DOCS: "/migrate-ops-docs",
};

export enum LICENSE_SUBROUTE {
    PURCHASE = "purchase",
    REQUEST = "request",
    ACTIVATE = "activate",
    WITHDRAW = "withdraw",
    RENEW = "renew",
}

export enum PROJECT_SUBROUTE {
    DASHBOARD = "dashboard",
    DEPLOYMENTS = "deployments",
    CMC_MIGRATIONS = "cmc-migrations",
    CMO_MIGRATIONS = "cmo-migrations",
    MIGRATE_OPS = "migrateops",
    DISASTER_RECOVERY = "dr",
    DR_DOCS = "dr-docs",
    MIGRATE_OPS_DOCS = "migrateops-docs",
    MIGRATE_OPS_HOST_ACTIONS = "migrateops-host-actions",
    MIGRATE_OPS_XRAYS = "migrateops-xrays",
    AI_AGENTS = "automations/ai",
    PROGRAMMATIC_ACCESS = "automations/programmatic-access",
    MANAGEMENT = "management",
    REPORTS = "reports",
    SETTINGS = "project-settings",
    INTEGRATIONS = "integrations",
    GLOBAL_MAP_VIEW = "deployments-map",
    PE_APPLIANCE = "pe-appliance",
}

export enum MANAGEMENT_SUBROUTE {
    LICENSE = "license",
}

export enum INTEGRATIONS_SUBROUTE {
    CREATE = "create",
    ENABLED = "enabled",
    AZURE_STORAGE_PLANNER = "azure-consumption-plans",
}

export enum CMC_MIGRATION_SUBROUTE {
    DEPLOYMENTS = "deployments",
    SESSIONS = "sessions",
    CONNECTIONS = "connections",
    UNSTRUCTURED_DATA = "unstructured-data",
    WIZARD = "wizard",
    AUTO_ALLOCATION = "auto-allocation",
    VOLUMES = "volumes", //under session id,
    WORKFLOW_RUNS = "workflow-runs", // deprecated; route intentionally not mounted
    QOS = "qos", // under volumes
    EDIT = "edit",
    XRAYS = "xrays",
}

export enum CMO_MIGRATION_SUBROUTE {
    DASHBOARD = "dashboard",
    CMO_SYSTEMS = "appliances",
    NEXUS = "nexus",
    MIGRATION_SESSIONS = "sessions",
    WARNINGS = "warnings",
}

export enum UNSTRUCTURED_DATA_SUBROUTE {
    CREATE = "create",
    EDIT = "edit",
    AUTO_CONNECT = "auto-connect",
}

export enum MIGRATE_OPS_SUBROUTE {
    CREATE = "create",
    BUILDER = "builder",
    WIZARD = "wizard",
}

export enum DISASTER_RECOVERY_SUBROUTE {
    NEW = "new",
    PROTECTED_WORKLOADS = "protected-workloads",
    SERVICE_LEVELS = "service-levels",
    REPLICATION_SESSIONS = "replication-sessions",
    OPERATIONS = "operations",
}

export enum MIGRATE_OPS_DOCS_SUBROUTE {
    GETTING_STARTED = "getting-started",
}

export enum DEPLOYMENT_SUBROUTE {
    DEPLOYED = "deployed",
    CONNECTIONS = "connections",
}

export enum DEPLOYMENT_DETAILS_SUBROUTE {
    HOST_INFO = "host-info",
    SETTINGS = "deployment-settings",
    RELAY = "management-relay",
    LOG = "live-log",
    LICENSE = "license",
    XRAYS = "xrays",
    PERFORMANCE = "performance",
    LABELS = "labels",
    H2H_RELAY = "h2h-relay",
    CONNECT_STORAGE = "connect-storage",
    MIGRATION_READINESS = "migration-readiness",
}

export enum CALLBACK_SUBROUTE {
    LICENSE_PURCHASE_SUCCESS = "purchase-success",
    LICENSE_PURCHASE_CANCELLED = "purchase-cancelled",
}

export const getProjectSubRouteTemplate = (sub: string) => {
    return `${APP_ROUTES.PROJECTS}/:projectId/${sub}`;
};

export const useQueryParams = () => {
    return new URLSearchParams(useLocation().search);
};
